import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

/**
 * Root layout component that:
 * 1. Disables the browser's native scroll restoration (which causes pages
 *    to load scrolled partway down on mobile).
 * 2. Scrolls the window to the top on every route change.
 *
 * Place this as the top-level <Route element={<ScrollToTopLayout />}>
 * wrapping all other routes in the router definition.
 */
export function ScrollToTopLayout() {
	const { pathname } = useLocation()

	// Disable browser-native scroll restoration on mount
	useEffect(() => {
		if ('scrollRestoration' in window.history) {
			window.history.scrollRestoration = 'manual'
		}
	}, [])

	// Scroll to top on every route change (including initial load)
	useEffect(() => {
		window.scrollTo(0, 0)
	}, [pathname])

	return <Outlet />
}
